<!--
 * @Author: wzh
 * @Date: 2023-07-31 11:20:51
 * @LastEditTime: 2024-05-23 16:32:43
 * @Description: 未绑定应用提示页面
-->
<template>
  <div class="not_app">
    <a-result status="warning" :title="`应用无法访问，请联系管理员。`" />
    <!-- <a-statistic-countdown :value="deadline" @finish="loginOut" /> -->
    <!-- <a-button danger size="large" @click="loginOut">去登录</a-button> -->
  </div>
</template>
<script>
export default {
  name: "NotAccess",
  data() {
    return {
      seconds: 3,
    };
  },
  created() {},
  mounted() {
    // this.countdown(this.seconds);
  },
  methods: {
    loginOut() {
      this.$store.dispatch("auth/loginOut");
    },
    countdown(seconds) {
      const that = this;
      var timeLeft = seconds;

      var interval = setInterval(function () {
        timeLeft--; // 减少剩余时间
        if (that.seconds > 0) that.seconds = timeLeft;
        if (timeLeft < 0) {
          clearInterval(interval); // 清除定时器
          // that.loginOut();
        }
      }, 1000); // 每秒更新一次
    },
  },
};
</script>
<style scoped lang="scss">
.not_app {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  padding: 40px 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
